import { FC } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { MediaBreakpoint, useBreakpointInfo } from '../../../hooks/useDeviceInfo';
import { joinStrings } from '../../../utils/string';
import './ItvSubNav.scss';
import { SubNav } from '../../../layouts/pages/ItvMain';

export const ItvSubNav: FC<{
  navItems?: SubNav[];
  mobileNavItems?: SubNav[];
}> = ({ navItems, mobileNavItems }) => {
  const isMobileOrTablet = useBreakpointInfo([MediaBreakpoint.MOBILE, MediaBreakpoint.TABLET]);

  const location = useLocation();

  const displayItems = isMobileOrTablet && mobileNavItems ? mobileNavItems : navItems;

  const isActive = (slug: string): boolean => {
    return location.pathname === slug;
  };

  const onClick = (): void => {
    window.scrollTo(0, 0);
  };

  return (
    <>
      {Boolean(displayItems?.length) && (
        <ul className="subnav-links">
          {displayItems?.map((navItem) => {
            const active = isActive(navItem.slug);

            return (
              <li key={navItem.slug}>
                <NavLink
                  key={navItem.slug}
                  to={navItem.slug + navItem.extraQueryParams}
                  className="subnav-links__link"
                  end
                  {...(active && { onClick })}
                >
                  {isMobileOrTablet && <img src={navItem.img} alt={navItem.title} className="subnav-links__icon" />}
                  <div className={joinStrings(['subnav-links__title', active && 'subnav-links__title--active'])}>
                    {navItem.title}
                  </div>
                </NavLink>
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};
